import { Component, Inject, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { CONFIG_TOKEN } from 'core/constants';
import { IXMOptions } from 'core/interfaces';
import { DataPlanType, UnlPlanSubgroup } from 'my-account/constants';
import { Subscription } from 'rxjs';
import { CimaCore, Cloudinary, Formatter } from 'services/index';
import { XmStore, XmStoreUtil } from 'services/store';
import { AccountSummary, LineSummary } from 'store/account-summary/models';
import { CmsDataDetail } from 'store/cms/models';

@Component({
    selector: 'btg-plan-detail-feature-seg-five',
    styleUrls: ['./btg-plan-detail-feature-seg-five.scss'],
    templateUrl: './btg-plan-detail-feature-seg-five.html',
    standalone: false
})
export class BtgPlanDetailFeatureForSegmentFive implements OnInit{
    @Input() public planData: CmsDataPlanDetails;
    public pageData: CmsDataDetail;
    public cmsDataDetailPageData: CmsDataDetail;
    public isBusinessUser: boolean;
    public accountSummary: AccountSummary;
    public lineSummary: LineSummary;
    public dataFeatures: CmsDetailPlanFeature[];
    public featureTitle: string;

    private state: StateService;
    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor(xmStore: XmStore, state: StateService, @Inject(CONFIG_TOKEN) config: IXMOptions, cimaCore: CimaCore) {
        Object.assign(this, { xmStore, state, config, cimaCore });
    }

    public ngOnInit(): void {

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
            this.cmsDataDetailPageData = pageData;
            this.pageData = pageData;
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AccountSummary>(AccountSummary), (accountSummary: AccountSummary) => {
            this.accountSummary = accountSummary;
            this.lineSummary = this.accountSummary.getLineByKey(this.state.params.line_id);
            this.dataFeatures = this.getDataFeatures();
        }));
    }

    public generateFeatureIcon(image: CmsMediaImage): MediaImageOptions {
        return {
            mobile: Cloudinary.generateMediaFromCms(image)
        };
    }

    private getDataFeatures(): CmsDetailPlanFeature[] {
        if (this.planData.planType === DataPlanType.BY_THE_GIG_SHARED){
            this.featureTitle = this.pageData.featureTitle;
            const features: CmsDetailPlanFeature[] = this.planData.scheduledSwitchByTheGigdataFeatures;

            return features && features.map((feature: CmsDetailPlanFeature) => ({
                ...feature,
                header: feature.header.replace('[CURRENT_PLAN]', this.getPlanName()).replace('[Date]', Formatter.formatMonthDate(this.lineSummary.scheduledSwitch.scheduleDate)),
                subheader: feature.subheader.replace('[CURRENT_PLAN]', this.getPlanName()).replace('[Date]', Formatter.formatMonthDate(this.lineSummary.scheduledSwitch.scheduleDate))
            }));
        }
    }
    private getPlanName(): string {
        switch (this.lineSummary?.planSubgroup) {
            case UnlPlanSubgroup.BASIC:
                return this.cmsDataDetailPageData.unlimited;
            case UnlPlanSubgroup.PREMIUM:
                return this.cmsDataDetailPageData.unlimitedPremium;
            default:
                return this.lineSummary?.planSubgroup;
        }
    }
}

